"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: n, size: l = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = s(), o = n !== null && n !== void 0 ? n : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = h();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M21.513 2.831q.006-.058.005-.109v-.024a1 1 0 0 0-.023-.137v-.01q-.008-.013-.009-.028a.5.5 0 0 0-.054-.137l-.04-.071a.717.717 0 0 0-.086-.104l-.019-.017q-.007-.01-.018-.017a.704.704 0 0 0-.298-.156q-.007-.004-.015-.005l-.016-.005a.6.6 0 0 0-.22-.002l-.02.002-.034.005q-.016.001-.033.005L2.99 7.03a.74.74 0 0 0-.519.654.75.75 0 0 0 .406.734l7.898 3.815-.696.73a.767.767 0 0 0 0 1.047c.276.29.723.29.998 0l.696-.73 3.634 8.289a.7.7 0 0 0 .642.431q.029.001.058-.005a.71.71 0 0 0 .623-.545l4.764-18.51.005-.028q0-.015.004-.029l.002-.01q.006-.02.007-.042m-3.066 1.35-6.606 6.934-6.601-3.19zm-5.608 7.981 6.606-6.933-3.567 13.861z"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M21.513 2.831q.006-.058.005-.109v-.024a1 1 0 0 0-.023-.137v-.01q-.008-.013-.009-.028a.5.5 0 0 0-.054-.137l-.04-.071a.717.717 0 0 0-.086-.104l-.019-.017q-.007-.01-.018-.017a.704.704 0 0 0-.298-.156q-.007-.004-.015-.005l-.016-.005a.6.6 0 0 0-.22-.002l-.02.002-.034.005q-.016.001-.033.005L2.99 7.03a.74.74 0 0 0-.519.654.75.75 0 0 0 .406.734l7.898 3.815-.696.73a.767.767 0 0 0 0 1.047c.276.29.723.29.998 0l.696-.73 3.634 8.289a.7.7 0 0 0 .642.431q.029.001.058-.005a.71.71 0 0 0 .623-.545l4.764-18.51.005-.028q0-.015.004-.029l.002-.01q.006-.02.007-.042m-3.066 1.35-6.606 6.934-6.601-3.19zm-5.608 7.981 6.606-6.933-3.567 13.861z"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M3 3.901a.904.904 0 0 1 1.308-.807l15.591 7.755a.907.907 0 0 1 .004 1.618L4.34 20.302a.906.906 0 0 1-1.292-.99l1.576-7.67-1.602-7.547A.8.8 0 0 1 3 3.901m1.186.366 1.567 7.37-1.54 7.492 14.836-7.472z"
        })
    }));
}, f = m;
export { f as default };
